/**
 * Motion helpers for the site — framer-motion based.
 * Uses per-item whileInView so async-loaded content still animates on arrival.
 */
import { motion } from "framer-motion";

// Section entrance: fade + rise when 15% visible.
export const FadeUp = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Grid wrapper — just a plain div; items animate themselves via whileInView.
export const StaggerGrid = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

// Each item fades up when scrolled into view (works even for async-loaded items).
export const StaggerItem = ({ children, className = "", index = 0, ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: Math.min(index * 0.06, 0.5) }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Hero-only page-load entrance (fires immediately on mount).
export const HeroFade = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export { motion };
